var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{ref:"iconElement",class:['zt-icon', 'align-middle leading-none tracking-normal', _vm.iconClass]})}
var staticRenderFns = []

export { render, staticRenderFns }